module.exports = __webpack_public_path__ + "static/media/mrd-cross-promo.9cf1ad5b.png";